<template>
  <layout-app>
    <HeaderTitle title="Dokumen" subtitle="Dokumen PPFTZ" />

    <div class="mb-3">
      <HandleDokumenForm />
    </div>
    <div class="card border-0 p-3">
      <div class="card-body">
        <div class="row justify-content-end">
          <v-text-field
            outlined
            dense
            prepend-inner-icon="mdi-magnify"
            placeholder="Cari..."
            style="max-width: 300px"
            v-model="optionsTable.search"
          />
        </div>
        <v-data-table
          :headers="headers"
          :items="reports"
          :loading="isLoading"
          :options.sync="optionsTable"
          :search="optionsTable.search"
        >
          <template v-slot:[`item.download`]="{ item }">
            <a :href="linkDownload(item.upload_id)" target="_blank">
              <v-btn class="btn btn-outline-primary" small>
                <i class="fa-solid fa-download"></i>
              </v-btn>
            </a>
          </template>
        </v-data-table>
      </div>
    </div>
  </layout-app>
</template>

<script>
import LayoutApp from "@/layouts/layout-app.vue";

export default {
  name: "NegaraPage",
  components: {
    LayoutApp,
    HeaderTitle: () => import("@/components/molecules/header-title"),
    HandleDokumenForm: () =>
      import("@/components/organisms/handle-dokumen-form"),
  },
  data() {
    return {
      headers: [
        { text: "No", value: "no" },
        { text: "Upload Id", value: "upload_id" },
        { text: "No.Dokumen", value: "document_number" },
        { text: "Tanggal Dokumen", value: "document_date" },
        { text: "Tanggal Expired", value: "document_expire" },
        { text: "Download", value: "download" },
      ],
      baseUrl: "https://api.batam-itinventory.com",
      linkDownload: (upload_id) => `${this.baseUrl}/documents/${upload_id}.pdf`,
    };
  },
  computed: {
    reports() {
      return this.$store.state.dokumen.reports;
    },
    isLoading() {
      return this.$store.state.dokumen.isLoading;
    },
    optionsTable: {
      get() {
        return this.$store.state.dokumen.optionsTable;
      },
      set(value) {
        this.$store.commit("SET_OPTIONS_TABLE_DOKUMEN", value);
      },
    },
  },
  created() {
    this.$store.dispatch("GetDokumen");
  },
};
</script>
